<script setup>
import { computed } from 'vue';
import { trans } from '../../../../_00_elements/translation';
import { currency } from '../../../../_00_elements/number-formatter';
import SubscriptionDetailsSection from './SubscriptionDetailsSection.vue';
import SubscriptionDetailsValue from './SubscriptionDetailsValue.vue';
import useSubscriptionStore from '../../store/subscriptions';
import { getCompleteReadableDate } from '../../../../_00_elements/tools/date';
import SubscriptionStatusTag from './SubscriptionStatusTag.vue';

const subscription = computed(() => useSubscriptionStore().selectedSubscriptionData);
</script>

<template>
  <SubscriptionDetailsSection>
    <template #details>
      <SubscriptionDetailsValue :label="trans('gestion.subscription.status')">
        <SubscriptionStatusTag v-if="subscription.status" :status="subscription.status" />
      </SubscriptionDetailsValue>
      <SubscriptionDetailsValue :label="trans('gestion.subscription.amount_ht')">
        {{ currency(subscription.amount / 100) }}
      </SubscriptionDetailsValue>
      <SubscriptionDetailsValue :label="trans('gestion.subscription.start_date')">
        {{ getCompleteReadableDate(subscription.start_date.iso ?? subscription.start_date.date) }}
      </SubscriptionDetailsValue>
      <SubscriptionDetailsValue :label="trans('gestion.subscription.end_date')">
        <span v-if="subscription.end_date">
          {{ getCompleteReadableDate(subscription.end_date.iso ?? subscription.end_date.date) }}
        </span>
        <span v-else>-</span>
      </SubscriptionDetailsValue>
    </template>
  </SubscriptionDetailsSection>
</template>
